import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './styles/NotFound.css';

const NotFound = () => {
  return (
    <main className="notfound">
      <Helmet>
        <title>Page non trouvée - WinlyDeal</title>
        <meta name="description" content="La page que vous recherchez n'existe pas. Revenez à l'accueil pour découvrir nos produits incroyables !" />
        <link rel="canonical" href="https://www.winlydeal.com/404" />
      </Helmet>

      <div className="notfound-content">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-message">Oups ! Cette page n'existe pas.</p>
        <Link to="/" className="notfound-button">
          Retour à l'accueil
        </Link>
      </div>
    </main>
  );
};

export default NotFound;
